/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolveIntegrationEventRequest
 */
export interface ResolveIntegrationEventRequest {
    /**
     * The chosen resolution for the event's flagged conflict. Validated server-side against the event's confirmation type (e.g. end-of-care accepts 'undo' or 'create_referral').
     */
    resolution: string;
}

/**
 * Check if a given object implements the ResolveIntegrationEventRequest interface.
 */
export function instanceOfResolveIntegrationEventRequest(value: object): value is ResolveIntegrationEventRequest {
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    return true;
}

export function ResolveIntegrationEventRequestFromJSON(json: any): ResolveIntegrationEventRequest {
    return ResolveIntegrationEventRequestFromJSONTyped(json, false);
}

export function ResolveIntegrationEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveIntegrationEventRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'resolution': json['resolution'],
    };
}

export function ResolveIntegrationEventRequestToJSON(json: any): ResolveIntegrationEventRequest {
    return ResolveIntegrationEventRequestToJSONTyped(json, false);
}

export function ResolveIntegrationEventRequestToJSONTyped(value?: ResolveIntegrationEventRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resolution': value['resolution'],
    };
}

